module.exports = __webpack_public_path__ + "media/components/src/assets/images/account_circle/account_circle-be04a720109eade72e2fe6a90470db74.svg";